import { Component, Inject, Prop, Vue, Watch } from "vue-property-decorator";
import ModalTemplate from "../../../../shared/components/ModalTemplate/ModalTemplate.vue";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import {
  COLLECTIONS_NAME,
  FORM_CONSTANTS,
  FORM_MESSAGES,
  FORM_VALIDATORS
} from "@/shared/constants/FormConstants";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { Http } from "@status/codes";
import { Response } from "@/shared/models/Response";
import { CupsPriceLevel } from "../../models/CupsPriceLevel";
import { CupsPriceLevelService } from "../../services/CupsPriceLevelService";
import {
  CUPS_ACCESS,
  CUPS_EVENTS,
  CUPS_PRICE_LEVEL_CONSTANTS,
  CUPS_VALIDATORS
} from "../../constants/CupsPriceLevelConstants";
import AddClients from "./AddClients/AddClients.vue";
import { Client } from "../../models/Clients";
import { Utils } from "@/shared/utils/utils";
import { AxiosError } from "axios";
import { ListService } from "@/modules/List/services/ListService";
import { LIST_ACCESS } from "@/modules/List/constants/ListConstants";
import { CupsForm } from "../../models/CupsForm.model";
@Component({
  name: "SaveCupsPriceLevel",
  components: {
    ModalTemplate,
    AddClients
  }
})
export default class SaveCupsPriceLevel extends Vue {
  @Inject() cupsPriceLevelService!: CupsPriceLevelService;
  @Inject() listService!: ListService;
  @Prop() documentId!: string;
  @Prop() isModal!: boolean;

  priBtnClass = STYLE_CLASSES.PRIMARY_BTN;
  btnRoundClassSecondary = STYLE_CLASSES.SECONDARY_ROUND_BTN;
  btnRoundClassTertiary = STYLE_CLASSES.TERTIARY_ROUND_BTN;
  secBtnClass = STYLE_CLASSES.SECONDARY_BTN;
  cardClass = STYLE_CLASSES.CARD;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  switchClass = STYLE_CLASSES.SWITCH;
  iconBtnClass = STYLE_CLASSES.ICON_BTN;

  pageTitle = CUPS_PRICE_LEVEL_CONSTANTS.PAGE_TITLE_CREATE;
  PAGE_START = FORM_CONSTANTS.BUTTON.PAGE_START;
  CUPS_NAME = CUPS_PRICE_LEVEL_CONSTANTS.LABEL.NAME;
  CUPS_PRICE = CUPS_PRICE_LEVEL_CONSTANTS.LABEL.PRICE;
  CUPS_URL = CUPS_PRICE_LEVEL_CONSTANTS.LABEL.URL_CUPS;
  CUPS_STATE = FORM_CONSTANTS.LABEL.STATE;
  SAVE_BTN = FORM_CONSTANTS.BUTTON.SAVE;
  CANCEL = FORM_MESSAGES.CANCEL_MODAL.TITLE;
  ADD_CLIENTS = CUPS_PRICE_LEVEL_CONSTANTS.BUTTON.ADD_CLIENTS;
  CUPS_CLIENTS = CUPS_PRICE_LEVEL_CONSTANTS.LABEL.CLIENT;
  CUPS_NAME_INFO = CUPS_PRICE_LEVEL_CONSTANTS.CUPS_INFO.NAME;
  CUPS_PRICE_INFO = CUPS_PRICE_LEVEL_CONSTANTS.CUPS_INFO.PRICE;
  PRIOR_ORDER = FORM_CONSTANTS.LABEL.PRIOR_ORDER;

  requiredField = [
    FORM_VALIDATORS.REQUIRED_FIELD,
    FORM_VALIDATORS.NOT_BLANK_SPACES_VALIDATOR
  ];
  maxLengthRule = [
    FORM_VALIDATORS.REQUIRED_FIELD,
    CUPS_VALIDATORS.MAX_LENGTH,
    FORM_VALIDATORS.NOT_BLANK_SPACES_VALIDATOR
  ];

  cupsPriceform = false;
  cupsPriceformEdit = false;
  dataSelectCups: CupsForm = {
    externalName: "",
    cups: "",
    state: false,
    clients: {},
    requiredPriorOrder: false
  };
  isEditing = false;
  isEditingClient = false;
  indexEditing = "";
  modalDialog = false;
  modalText = "";
  modalTitle = "";
  cupsPriceLevel!: CupsPriceLevel;
  clientsEdit = {};
  showAddClients = true;
  errorsName: string[] = [];
  listClients: { id: string; name: string }[] = [];
  keyAddClient = 0;
  invalidEdit = false;
  editComparatrionStr = "";

  mounted() {
    this.handleDocumentId();
  }

  eventFormEdit() {
    this.cupsPriceformEdit = true;
    this.handleDataSelectCups();
  }

  @Watch("dataSelectCups", { deep: true })
  async handleDataSelectCups() {
    if (this.isEditing) {
      this.invalidEdit =
        JSON.stringify(this.dataSelectCups) === this.editComparatrionStr;
    }
  }

  @Watch("documentId")
  async handleDocumentId() {
    this.dataSelectCups = {
      externalName: "",
      cups: "",
      state: true,
      clients: {},
      requiredPriorOrder: false
    };
    this.cupsPriceformEdit = false;
    Utils.moveElement(
      CUPS_PRICE_LEVEL_CONSTANTS.CLIENTS_COMPONENT_ID,
      CUPS_PRICE_LEVEL_CONSTANTS.CLIENTS_COMPONENT_CONTAINER_ID
    );
    this.isEditingClient = false;
    if (this.documentId && this.documentId !== "") {
      this.isEditing = true;
      this.invalidEdit = true;
      this.showAddClients = false;
      this.cupsPriceLevel = (await this.getCupsPriceLevelById(
        this.documentId as string
      )) as CupsPriceLevel;
    } else {
      this.resetData();
      this.isEditing = false;
      this.indexEditing = "";
      this.showAddClients = true;
    }
    this.getListClients();
    this.$emit(CUPS_PRICE_LEVEL_CONSTANTS.SCROLL);
  }

  async getCupsPriceLevelById(id: string) {
    try {
      const response = await this.cupsPriceLevelService.getCupsPriceLevelById(
        id
      );

      if (response.code === Http.Found && response.data) {
        this.fillPriceLvlForm(response.data);
        return response.data as CupsPriceLevel;
      } else {
        Snackbar.popInfo(response.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + CUPS_ACCESS.GET);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  fillPriceLvlForm(data: CupsPriceLevel) {
    this.dataSelectCups.externalName = data.externalName;
    this.dataSelectCups.cups = data.cups;
    this.dataSelectCups.clients = data.clients;
    this.dataSelectCups.state =
      data.state === FORM_CONSTANTS.STATE.ACTIVE ? true : false;
    this.dataSelectCups.requiredPriorOrder = data.requiredPriorOrder;

    this.editComparatrionStr = JSON.stringify(this.dataSelectCups);
  }

  onSave() {
    this.modalTitle = FORM_MESSAGES.SAVE_MODAL.TITLE;
    this.modalText = FORM_MESSAGES.SAVE_MODAL.MESSAGE;
    this.modalDialog = true;
  }

  onAddClient() {
    this.indexEditing = "";
    this.isEditingClient = false;
    this.showAddClients = true;
    Utils.moveElement("addClientComponent", "addClientComponentContainer");
    Utils.scrollToElement(
      CUPS_PRICE_LEVEL_CONSTANTS.CLIENTS_COMPONENT_ID,
      this
    );
  }

  onCloseModal() {
    this.$emit(CUPS_EVENTS.CANCEL);
  }

  async handleModalAccept() {
    this.modalDialog = false;

    if (this.modalTitle === FORM_MESSAGES.SAVE_MODAL.TITLE) {
      if (Object.entries(this.dataSelectCups.clients).length > 0) {
        await this.saveCupsPriceLevel();
      } else {
        Snackbar.popWarning(CUPS_PRICE_LEVEL_CONSTANTS.MESSAGE.CLIENT_MIN);
      }
    } else if (this.modalTitle === FORM_MESSAGES.CANCEL_MODAL.TITLE) {
      this.$router.go(-1);
    }
  }

  handleModalCancel() {
    this.modalDialog = false;
  }

  async saveCupsPriceLevel() {
    try {
      const cupsPriceLevelToSave: CupsPriceLevel = {
        externalName: this.dataSelectCups.externalName.trim(),
        cups: this.dataSelectCups.cups.trim(),
        state: this.dataSelectCups.state
          ? FORM_CONSTANTS.STATE.ACTIVE
          : FORM_CONSTANTS.STATE.INACTIVE,
        clients: this.dataSelectCups.clients,
        requiredPriorOrder: this.dataSelectCups.requiredPriorOrder
      };
      let response: Response<string | void>;

      if (this.isEditing) {
        cupsPriceLevelToSave.dateChanged = Date.now();
        cupsPriceLevelToSave.dateCreated = this.cupsPriceLevel.dateCreated;
        cupsPriceLevelToSave.createdBy = this.cupsPriceLevel.createdBy;
        cupsPriceLevelToSave.changedBy = localStorage.getItem(
          FORM_CONSTANTS.UID_TEXT
        );

        response = await this.cupsPriceLevelService.updateCupsPriceLevel(
          this.cupsPriceLevel.id as string,
          cupsPriceLevelToSave
        );
      } else {
        cupsPriceLevelToSave.dateChanged = Date.now();
        cupsPriceLevelToSave.dateCreated = Date.now();
        cupsPriceLevelToSave.createdBy = localStorage.getItem(
          FORM_CONSTANTS.UID_TEXT
        );

        const existPriceLevel = await this.cupsPriceLevelService.checkIfCupsPriceLevelExists(
          this.dataSelectCups.cups
        );

        if (existPriceLevel.code !== Http.Found) {
          response = await this.cupsPriceLevelService.addCupsPriceLevel(
            cupsPriceLevelToSave
          );
        } else {
          Snackbar.popWarning(CUPS_PRICE_LEVEL_CONSTANTS.MESSAGE.CUPS_EXISTS);
          return;
        }
      }

      if (response.code === Http.Ok) {
        Snackbar.popSuccess(response.message);
        this.$emit(CUPS_PRICE_LEVEL_CONSTANTS.EMIT.UPDATE);
        this.$emit(
          CUPS_PRICE_LEVEL_CONSTANTS.EMIT.EVENT_SERVICE_CUPS,
          cupsPriceLevelToSave.externalName,
          true
        );
      } else {
        Snackbar.popError(response.message);
      }
    } catch (error) {
      const METHOD = Utils.getMethodHTTP(
        error as AxiosError
      ) as keyof typeof CUPS_ACCESS;
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          `${FORM_MESSAGES.FORBIDDEN_REQUEST}${CUPS_ACCESS[METHOD]}`
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  handleCloseAddClients() {
    this.isEditingClient = false;
    this.indexEditing = "";
    this.showAddClients = false;
    Utils.moveElement("addClientComponent", "addClientComponentContainer");
  }

  deleteClient(key: string) {
    Vue.delete(this.dataSelectCups.clients, key);
    this.handleCloseAddClients();
  }

  updateClient(key: string) {
    this.isEditingClient = true;
    this.indexEditing = key;
    this.showAddClients = true;
    Utils.moveElement("addClientComponent", "addClient" + key);
    Utils.scrollToElement("addClientComponent", this);
  }

  goToStart(id: string) {
    Utils.scrollToElement(id, this);
  }

  resetData() {
    this.dataSelectCups.clients = {};
    this.dataSelectCups.externalName = "";
    this.dataSelectCups.cups = "";
  }

  async validateUniqueName() {
    this.errorsName = await Utils.checkUniqueName(
      COLLECTIONS_NAME.CUPS_PRICE_LEVEL,
      this.dataSelectCups.externalName
    );
  }

  async getListClients() {
    try {
      const response = await this.listService.getListById(
        CUPS_PRICE_LEVEL_CONSTANTS.LIST_CLIENTS_ID
      );
      this.listClients = response.data?.options
        .filter(client => client.enabled === true)
        .map(e => ({ id: e.value, name: e.title, code: e.id }))!;

      if (this.isEditing)
        this.addClientsToListIfNotExist(this.dataSelectCups.clients);

      this.keyAddClient++;
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + LIST_ACCESS.GET);
      else {
        Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
      }
    }
  }

  handleCloseAddList() {
    this.getListClients();
  }

  addClientsToListIfNotExist(clients: Client) {
    for (const key in clients) {
      if (!this.listClients.find(client => client.name === clients[key].name)) {
        this.listClients.push({
          id: clients[key].name,
          name: clients[key].name
        });
      }
    }
  }
}
